import { useState } from "react";
import { useApp } from "../../contexts";
import { FormSelect } from "../Form";
import moment from "moment";
import { DatePickerView } from "../DatePicker";

const DATE_OPTION = {
  OPT_7_DAYS: "7days",
  OPT_30_DAYS: "30days",
  OPT_60_DAYS: "60days",
  OPT_CUSTOMIZED: "customized",
};

/**
 * @typedef {Object} query
 * @property {DATE_OPTION} selected
 * @property {moment} fromDate
 * @property {moment} toDate
 */

export const DateRangeSelect = ({ value, onChange }) => {
  const { T } = useApp();
  const [showDatePicker, setShowDatePicker] = useState(false);

  const handleSelect = (value) => {
    const newVal = {};

    switch (value) {
      case DATE_OPTION.OPT_7_DAYS: {
        newVal.fromDate = moment()
          .startOf("day")
          .subtract(7, "days")
          .toDate()
          .getTime();
        newVal.toDate = moment().endOf("day").toDate().getTime();
        break;
      }
      case DATE_OPTION.OPT_30_DAYS: {
        newVal.fromDate = moment()
          .startOf("day")
          .subtract(30, "days")
          .toDate()
          .getTime();
        newVal.toDate = moment().endOf("day").toDate().getTime();
        break;
      }
      case DATE_OPTION.OPT_60_DAYS: {
        newVal.fromDate = moment()
          .startOf("day")
          .subtract(60, "days")
          .toDate()
          .getTime();
        newVal.toDate = moment().endOf("day").toDate().getTime();
        break;
      }
      case DATE_OPTION.OPT_CUSTOMIZED: {
        setShowDatePicker(true);
        break;
      }
      default: {
        newVal.fromDate = undefined;
        newVal.toDate = undefined;
      }
    }
    if (value !== DATE_OPTION.OPT_CUSTOMIZED) {
      newVal.selected = value;
    }

    onChange(newVal);
  };

  const handleDatePickerChange = (event) => {
    const newVal = {};
    newVal.selected = DATE_OPTION.OPT_CUSTOMIZED;
    newVal.fromDate = event.fromDate.startOf("day").toDate().getTime();
    newVal.toDate = event.toDate.endOf("day").toDate().getTime();
    onChange(newVal);
    setShowDatePicker(false);
  };

  return (
    <>
      <FormSelect
        allowClear={false}
        value={value?.selected}
        onSelect={(value) => {
          switch (value) {
            case "customized":
              setShowDatePicker(true);
              break;
            default:
              break;
          }
        }}
        onChange={handleSelect}
      >
        <FormSelect.Option value={null}>{T("All")}</FormSelect.Option>
        <FormSelect.Option value={DATE_OPTION.OPT_7_DAYS}>
          {T("Last 7 days")}
        </FormSelect.Option>
        <FormSelect.Option value={DATE_OPTION.OPT_30_DAYS}>
          {T("Last 30 days")}
        </FormSelect.Option>
        <FormSelect.Option value={DATE_OPTION.OPT_60_DAYS}>
          {T("Last 60 days")}
        </FormSelect.Option>
        <FormSelect.Option value={DATE_OPTION.OPT_CUSTOMIZED}>
          {value?.selected === DATE_OPTION.OPT_CUSTOMIZED
            ? `${moment(value.fromDate).format("DD/MM/YYYY")} - ${moment(
                value.toDate
              ).format("DD/MM/YYYY")}`
            : T("Customized")}
        </FormSelect.Option>
      </FormSelect>

      {showDatePicker ? (
        <DatePickerView
          fromDate={value.fromDate}
          toDate={value.toDate}
          onCancel={() => {
            setShowDatePicker(false);
          }}
          onChange={handleDatePickerChange}
        />
      ) : null}
    </>
  );
};
